<mat-form-field appearance="fill"
                [formGroup]="group"
                fxFlex>

  <mat-label>{{field.label}}</mat-label>

  <mat-select [formControlName]="field.name">
    <mat-option *ngFor="let item of field.options"
                [value]="item.value">{{item.label}}</mat-option>
  </mat-select>

  <ng-container
    *ngFor="let validation of field.validations;"
    ngProjectAs="mat-error">
    <mat-error *ngIf="group.get(field.name)?.hasError(validation.name)"
               [translate]="validation.message"
               [translateParams]="{field:field.label,max:field.maxLength}">
    </mat-error>
  </ng-container>
</mat-form-field>
